// import { Grid, Paper, Typography } from "@mui/material";
// import React from "react";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import WSDashboardCard from "../../../Components/CardListing/WSDashboardCard";
// import WSDateField from "../../../Components/DateField/WSDateField";
// import WSSelectField from "../../../Components/Select/WSSelect";
// import dashboardBg from "../../../images/dashboard-bg-card.svg";
// import { useForm } from "react-hook-form";
// import { useDispatch } from "react-redux";
// import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
// import {
//   IsSmallScreen,
//   updateMainHeader,
// } from "../../../commonFunctions/CommonFunctions";
// import { useNavigate } from "react-router-dom";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import config from "../../../Config/clientConfig.json";
// import { LabRecentOrders } from "./LabRecentOrders";
// import WeeklyChart from "./SummarySalesChart";
// import { LabRecentNotification } from "./LabRecentNotification";
// import LabProductsCard from "./LabProductCard";

// export const LabOverview: React.FC<any> = React.memo((props) => {
//   const { control, register } = useForm();
//   const navigate = useNavigate();
//   const isMobile = IsSmallScreen();
//   const dispatch = useDispatch();
//   const { showMessage } = useSnackbar();

//   updateMainHeader("Dashboard");
//   breadCrumbsStore.updateBreadCrumbs([{ Overview: "/lab-overview" }]);
//   return (
//     <>
//       {/* ---------------- Welcome Section ---------------- */}
//       <Paper
//         elevation={0}
//         sx={{
//           p: 3,
//           mt: 1,
//           mb: 2,
//           borderRadius: 3,
//           backgroundImage: `url(${dashboardBg})`,
//           backgroundSize: "cover",
//           backgroundRepeat: "no-repeat",
//           backgroundPosition: "center",
//         }}
//       >
//         <Grid container spacing={2}>
//           <Grid item xs={12} sm={8}>
//             <Typography
//               variant="h5"
//               fontWeight={600}
//               style={{ color: "#098963" }}
//             >
//               Hello, Biolab Advanced Diagnostic Centre 🖐️
//             </Typography>
//             <Typography sx={{ color: "#022219", mt: 0.5 }}>
//               “Get a quick snapshot of your lab’s performance today{" "}
//             </Typography>
//             <Typography sx={{ color: "#828584", mt: 1 }}>
//               Monday, 23-06-2025
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={2}>
//             <WSSelectField
//               rules={{ required: true }}
//               {...register("days")}
//               id="days"
//               control={control}
//               label=""
//               name="days"
//               isInGridFilter={true}
//               options={config.dayConfig.staticOptionData}
//             />
//           </Grid>
//           <Grid item xs={12} sm={2}>
//             <WSDateField
//               id={"dob"}
//               name={"dob"}
//               label={"DOB"}
//               dateFormat="DD-MM-YYYY"
//               control={control}
//               isInGridFilter={true}
//               defaultValue={null}
//               rules={{ required: false }}
//             />
//           </Grid>
//           <Grid item xs={12} sm={3}>
//             <WSDashboardCard
//               title="Today Orders"
//               value="100"
//               percentage="+2.5%"
//               bottomIcon={<WSIcons.TrendingUp />}
//               icon={<WSIcons.ShoppingCartIcon sx={{ color: "#098963" }} />}
//             />
//           </Grid>

//           <Grid item xs={12} sm={3}>
//             <WSDashboardCard
//               title="Pending Collections"
//               value="40"
//               percentage="+2.5%"
//               bottomIcon={<WSIcons.TrendingUp />}
//               icon={<WSIcons.ShoppingCartIcon sx={{ color: "#098963" }} />}
//             />
//           </Grid>

//           <Grid item xs={12} sm={3}>
//             <WSDashboardCard
//               title="Reports Pending"
//               value="20"
//               percentage="+2.5%"
//               bottomIcon={<WSIcons.TrendingUp />}
//               icon={<WSIcons.ShoppingCartIcon sx={{ color: "#098963" }} />}
//             />
//           </Grid>

//           <Grid item xs={12} sm={3}>
//             <WSDashboardCard
//               title="Cancellations"
//               value="40"
//               percentage="+2.5%"
//               bottomIcon={<WSIcons.TrendingUp />}
//               icon={<WSIcons.ShoppingCartIcon sx={{ color: "#098963" }} />}
//             />
//           </Grid>
//           <Grid item xs={12} sm={3}>
//             <WSDashboardCard
//               title="Low Stock Alerts"
//               value="40"
//               percentage="+2.5%"
//               bottomIcon={<WSIcons.TrendingUp />}
//               icon={<WSIcons.ShoppingCartIcon sx={{ color: "#098963" }} />}
//             />
//           </Grid>
//           <Grid item xs={12} sm={3}>
//             <WSDashboardCard
//               title="Earnings"
//               value="40"
//               percentage="+2.5%"
//               bottomIcon={<WSIcons.TrendingUp />}
//               icon={<WSIcons.ShoppingCartIcon sx={{ color: "#098963" }} />}
//             />
//           </Grid>
          
//         </Grid>
//       </Paper>
//       <Grid container spacing={2}>
//         {/* First Column */}
//         <Grid item xs={12} sm={8}>
//           <Grid container spacing={2} direction="column">
//             <Grid item>
//               {" "}
//               <LabRecentOrders />
//             </Grid>
//             <Grid item>
//               {" "}
//               <WeeklyChart />
//             </Grid>
//           </Grid>
//         </Grid>

//         {/* Second Column */}
//         <Grid item xs={12} sm={4}>
//           <Grid container spacing={2} direction="column">
//             <Grid item>
//               {" "}
//               <LabRecentNotification />
//             </Grid>
//             <Grid item>
//               {" "}
//               <LabProductsCard />
//             </Grid>
//           </Grid>
//         </Grid>
//       </Grid>
//     </>
//   );
// });



import { Grid, Paper, Typography } from "@mui/material";
import React, { useState, useEffect, useCallback } from "react";
import { WSIcons } from "../../../commonFunctions/iIcons";
import WSDashboardCard from "../../../Components/CardListing/WSDashboardCard";
import WSDateField from "../../../Components/DateField/WSDateField";
import WSSelectField from "../../../Components/Select/WSSelect";
import dashboardBg from "../../../images/dashboard-bg-card.svg";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import {
  IsSmallScreen,
  updateMainHeader,
  getLocalValue,
  LoacalVariables,
} from "../../../commonFunctions/CommonFunctions";
import { useNavigate } from "react-router-dom";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import config from "../../../Config/clientConfig.json";
import { LabRecentOrders } from "./LabRecentOrders";
import WeeklyChart from "./SummarySalesChart";
import { LabRecentNotification } from "./LabRecentNotification";
import LabProductsCard from "./LabProductCard";
import { callAPI, Method } from "../../../commonFunctions/CommonFunctions";

interface LabDashboardData {
  todayOrders: number;
  pendingCollections: number;
  reportsPending: number;
  cancellations: number;
  lowStockAlerts: number;
  earnings: number;
  recentOrders: any[];
}

// Replace your ENTIRE LabOverview component with this:
export const LabOverview: React.FC<any> = React.memo((props) => {
  const { control, register } = useForm();
  const navigate = useNavigate();
  const isMobile = IsSmallScreen();
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();

  const [labId, setLabId] = useState<string>("");
  const [dashboardData, setDashboardData] = useState<any>({
    todayOrders: 0,
    pendingCollections: 0,
    reportsPending: 0,
    cancellations: 0,
    lowStockAlerts: 0,
    earnings: 0,
    recentOrders: [],
  });
  const [loading, setLoading] = useState(true);

  // Load labId on mount
  useEffect(() => {
    const userId = getLocalValue(LoacalVariables.UserId);
    if (userId) {
      console.log('🚀 Loading labId:', userId);
      setLabId(userId);
    }
  }, []);

  // Fetch dashboard data - FIXED response handling
  const fetchDashboardData = useCallback(async () => {
    if (!labId) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      console.log("📡 FETCHING LAB DASHBOARD:", labId);
      const response: any = await callAPI(`lab/LabDashBoard/${labId}`, Method.GET);
      
      console.log('✅ FULL API RESPONSE:', response);
      console.log('✅ RESPONSE.DATA:', response?.data);
      
      // ✅ FIXED: Handle both response.data and direct response
      const apiData = response?.data || response;
      console.log('✅ PROCESSED DATA:', apiData);
      
      setDashboardData({
        todayOrders: apiData.todayOrders || 0,
        pendingCollections: apiData.pendingCollections || 0,
        reportsPending: apiData.reportsPending || 0,
        cancellations: apiData.cancellations || 0,
        lowStockAlerts: apiData.lowStockAlerts || 0,
        earnings: apiData.earnings || 0,
        recentOrders: apiData.recentOrders || [],
      });
      
      console.log('✅ STATE UPDATED:', {
        todayOrders: apiData.todayOrders,
        reportsPending: apiData.reportsPending,
        earnings: apiData.earnings
      });
      
    } catch (error: any) {
      console.error("💥 LAB DASHBOARD ERROR:", error);
      showMessage("Failed to load dashboard data", "error");
    } finally {
      setLoading(false);
    }
  }, [labId, showMessage]);

  useEffect(() => {
    if (labId) {
      fetchDashboardData();
    }
  }, [labId, fetchDashboardData]);

  updateMainHeader("Dashboard");
  breadCrumbsStore.updateBreadCrumbs([{ Overview: "/lab-overview" }]);

  // ✅ DEBUG: Show current state
  console.log('🎯 CURRENT dashboardData:', dashboardData);

  if (loading) {
    return (
      <Paper sx={{ p: 3, mt: 1, mb: 2, borderRadius: 3, minHeight: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography>Loading dashboard...</Typography>
      </Paper>
    );
  }

  return (
    <>
      <Paper elevation={0} sx={{
        p: 3, mt: 1, mb: 2, borderRadius: 3,
        backgroundImage: `url(${dashboardBg})`,
        backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center",
      }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={8}>
            <Typography variant="h5" fontWeight={600} style={{ color: "#098963" }}>
              Hello, Biolab Advanced Diagnostic Centre 🖐️
            </Typography>
            <Typography sx={{ color: "#022219", mt: 0.5 }}>
              Get a quick snapshot of your lab's performance today
            </Typography>
            <Typography sx={{ color: "#828584", mt: 1 }}>
              Thursday, 15-01-2026
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={2}>
            <WSSelectField
              rules={{ required: true }}
              {...register("days")}
              id="days"
              control={control}
              label=""
              name="days"
              isInGridFilter={true}
              options={config.dayConfig.staticOptionData}
            />
          </Grid>
          
          <Grid item xs={12} sm={2}>
            <WSDateField
              id="dob" name="dob" label="DOB" dateFormat="DD-MM-YYYY"
              control={control} isInGridFilter={true} defaultValue={null}
              rules={{ required: false }}
            />
          </Grid>

          {/* ✅ FIXED: Using REAL API DATA */}
          <Grid item xs={12} sm={3}>
            <WSDashboardCard
              title="Today Orders"
              value={dashboardData.todayOrders.toString()}
              percentage="+2.5%"
              bottomIcon={<WSIcons.TrendingUp />}
              icon={<WSIcons.ShoppingCartIcon sx={{ color: "#098963" }} />}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <WSDashboardCard
              title="Pending Collections"
              value={dashboardData.pendingCollections.toString()}
              percentage="-1.2%"
              bottomIcon={<WSIcons.TrendingUp />}
              icon={<WSIcons.ShoppingCartIcon sx={{ color: "#ff9800" }} />}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <WSDashboardCard
              title="Reports Pending"
              value={dashboardData.reportsPending.toString()}
              percentage="+5.3%"
              bottomIcon={<WSIcons.TrendingUp />}
              icon={<WSIcons.ShoppingCartIcon sx={{ color: "#f44336" }} />}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <WSDashboardCard
              title="Cancellations"
              value={dashboardData.cancellations.toString()}
              percentage="-0.5%"
              bottomIcon={<WSIcons.TrendingUp />}
              icon={<WSIcons.ShoppingCartIcon sx={{ color: "#9c27b0" }} />}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <WSDashboardCard
              title="Low Stock Alerts"
              value={dashboardData.lowStockAlerts.toString()}
              percentage="+3.1%"
              bottomIcon={<WSIcons.TrendingUp />}
              icon={<WSIcons.ShoppingCartIcon sx={{ color: "#ffeb3b" }} />}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <WSDashboardCard
              title="Earnings"
              value={`₹${dashboardData.earnings.toLocaleString()}`}
              percentage="+12.5%"
              bottomIcon={<WSIcons.TrendingUp />}
              icon={<WSIcons.ShoppingCartIcon sx={{ color: "#4caf50" }} />}
            />
          </Grid>
        </Grid>
      </Paper>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={8}>
          <Grid container spacing={2} direction="column">
            <Grid item><LabRecentOrders /></Grid>
            <Grid item><WeeklyChart /></Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={4}>
          <Grid container spacing={2} direction="column">
            <Grid item><LabRecentNotification /></Grid>
            <Grid item><LabProductsCard /></Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
});
